<template>
    <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
        <div :style="{ 'z-index': (currentZIndex)}"
        class="dimmed_black" style="top:0;display:block;"></div>
        <div :style="{ 'z-index': (currentZIndex+1)}"
         class="rew19_popContainer big" id="pop_paymentinfo" style="display:block;">
          <div class="rew19_popup_wrap">
            <h2>
                <span class="rew19_basketList_tit">정기구매 타입 변경 안내</span>
                <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
            </h2>
          </div>
          <div class="rew19_popup_cont">
          <p class="rew19_normalTxt">안녕하세요 <span class="rew19_point">{{getMemberNmKr()}}</span> 고객님 <br> 
            오랜시간 변함없이 뉴스킨 정기구매를 이용해 주셔서 진심으로 감사드립니다. <br> <br>   뉴스킨은 2019년 12월 enJoy 멤버쉽 프로그램을 론칭 하면서 정기구매 서비스 및 혜택을  멤버십 기반으로 통합하여 운영하게 되었습니다.
            <br> <br>  이에 지난 2002년~2006년간 한시적으로 운영했던 15% ADP(일부 제품 15% 할인) 서비스는  2020년 4월 1일 부터 종료됨을 알려드립니다.
            <br> <br>  enJoy 멤버십을 통해 보다 나은 서비스를 드리기 위해 지속 노력하겠습니다.
          </p>
          <div class="rew19_payment_list-total"><strong>정기구매 타입 변경</strong></div>
          <table class="rew19-table-col">
            <caption>콜 테이블</caption>
            <colgroup>
                <col>
                <col>
                <col>
            </colgroup>
            <thead>
              <tr>
                  <th class="table-col__head">구분</th>
                  <th class="table-col__head">변경 전</th>
                  <th class="table-col__head">변경 후</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                  <td class="table-col__data">정기구매 타입</td>
                  <td class="table-col__data">ADP</td>
                  <td class="table-col__data">일반 정기구매</td>
              </tr>
              <tr>
                  <td class="table-col__data">할인율</td>
                  <td class="table-col__data">15%</td>
                  <td class="table-col__data">10%</td>
              </tr>
              <tr>
                  <td class="table-col__data">제품 변경</td>
                  <td class="table-col__data">불가</td>
                  <td class="table-col__data">가능</td>
              </tr>
              <tr>
                  <td colspan="3" class="table-col__data">
                    <ul class="rew19_dotList topGepDesk">
                      <li>기존 정기구매 정보(결제일, 제품, 결제 정보, 진행 회차 등)는 그대로 유지됩니다.</li>
                      <li class="point_red">신청하신 사항은 2020년 4월 1일부터 적용됩니다.</li>
                    </ul>
                  </td>
              </tr>
            </tbody>
          </table>

          <div class="select_wapper">
            <dl class="rew19_select_table">
              <dd class="rew19_payment_container rew19_payment_lineup">
                  <ul class="rew19_clear">
                    <li class="rew19_wrapRadio_t1 rew19_lineup_left">
                      <input type="radio" 
                      class="rew19_fakeRadio_t1" 
                      id="fake-radio_change01"
                      v-model="viewData.check_type"
                      value="ARO">
                      <label for="fake-radio_change01">
                          전환 신청
                      </label>
                    </li>
                    <li class="rew19_wrapRadio_t1 rew19_lineup_left">
                    <input type="radio" 
                    class="rew19_fakeRadio_t1" 
                    id="fake-radio_change02"
                    v-model="viewData.check_type"
                    value="CANCEL">
                    <label for="fake-radio_change02">
                      철회 신청
                    </label>
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
            <div class="rew19_termwrap" v-show="viewData.check_type == 'ARO'">
                <div v-html="adpTransformTerm" class="rew19_termbox">
                    
                </div>
                <div class="rew19_wrapCheck_t1">
                  <input type="checkbox" id="typeChangeTerm01" class="rew19_fakeCheck_t1" v-model="typeChangeTerm">
                  <label for="typeChangeTerm01">상기 내용에 대해서 읽고 동의합니다.</label>
                </div>
            </div>
          </div><!--//rew19_popup_cont-->

          <div class="rew19_popup_btn rew19_clear">
              <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
              <button class="rew19_popHarf activation" @click="onCheck">확인</button>
          </div>
        </div>
    </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as ErrMsg from "@/utils/error_msg";
import * as Const from "@/utils/const";

export default {
  name: 'AdpTransformDialog',
  extends: AroBase,
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {      
      currentZIndex : 2000,
      viewData: {
        check_type : 'ARO'
      },
      typeChangeTerm : false,
      adpTransformTerm : "",
    }
  },
  created(){
    let _this = this;
    
    _this.$http.get(_this.$aroApiBasePath + Const.VALUE_ADP_TRANSFORM_TERM).then(res=>{
      _this.adpTransformTerm = res.data;
    });
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);
      
      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;
  },  
  methods :{
    onClose(response) {
      let _this = this;

      _this.$emit('close', response, response ? _this.viewData : null);      
    },
    onCancel(){
      this.onClose(false);
    },
    onCheck() {
      let _this = this;

      if(_this.viewData.before_check_type == ''){
        _this.onOk();
      }else if(_this.viewData.before_check_type == 'ARO' && _this.viewData.check_type == 'ARO'){
         _this.$dialogs.alert("이미 전환 신청하신 회원입니다")
          .then(res => {
            _this.onCancel();
          });
      }else if(_this.viewData.before_check_type == 'ARO' && _this.viewData.check_type == 'CANCEL'){
         _this.$dialogs.alert("이미 전환 신청하신 회원입니다. 철회 신청으로 변경하시겠습니까?")
          .then(res => {
            if(res.ok){
              _this.onOk();
            }
          });
      }else if(_this.viewData.before_check_type == 'CANCEL' && _this.viewData.check_type == 'ARO'){
         _this.$dialogs.alert("이미 철회 신청하신 회원입니다.  전환 신청으로 변경하시겠습니까?")
          .then(res => {
            if(res.ok){
              _this.onOk();
            }
          });
      }else if(_this.viewData.before_check_type == 'CANCEL' && _this.viewData.check_type == 'CANCEL'){
         _this.$dialogs.alert("이미 철회 신청하신 회원입니다")
          .then(res => {
            _this.onCancel();
          });
      }
      
    },
    onOk() {
      let _this = this;

      if(_this.viewData.check_type == 'ARO' && _this.typeChangeTerm != true){
        _this.$dialogs.alert("타입 전환 약관에 동의해 주세요.")
          .then(res => {
          });
          return false;
      }

      //show loading
      _this.$showLoading();      
      _this.apiAdpTransform().then((res)=>{
        if (res.status === 200 && res.data.status === "0000") { 
            if(_this.viewData.check_type == "ARO"){       
             _this.$dialogs.alert("정기구매 전환 신청이 완료 되었습니다.")
              .then(res => {
                this.onClose(true);
              });
            }else{
               _this.$dialogs.alert("정기구매 철회 신청이 완료 되었습니다.")
              .then(res => {
                this.onClose(true);
              });
            }
          }else{
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_ERROR_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
        }
  
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });

    },

    /**
     * API Request
     */   

    // ADP 전환 신청 조회
    apiGetAdpTransform: function(transformInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/adp/get`, {
          params : {
            ...transformInfo
          }
      });
    },

    // ADP 전환 신청
    apiAdpTransform: function(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/adp/transform`, {
          params : {
            adp_no : _this.viewData.adp_no,
            check_type : _this.viewData.check_type
          }
      });
    },

    /**
     * Local 
     */
    initData : function(data){
      let _this = this;

      _this.apiGetAdpTransform(data).then((res)=>{
        if (res.status === 200 && res.data.status === "0000") {        
             _this.viewData = {...res.data};
             _this.typeChangeTerm = false;
          }else{
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
        }
  
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },
  }
}
</script>
<style>
  .point_red {color:#ff0000 !important; font-weight: bold;}
</style>


// WEBPACK FOOTER //
// src/components/popup/AdpTransformDialog.vue